<template>
    <div class="main noTakeaway">
        <Banner :banner="banner"/>
        <Headlines :headlines="headlines"/>

        <div class="content-box">
            <div class="left-box">
                <Article :article="broadcast"/>
                <Shuffling :swiper="coredata"/>
                <Project :project="project"/>
            </div>

            <Rightbox/>
        </div>
    </div>
</template>

<script>
export default {
    name: '2021Q2payscb',
    // meta配置
    metaInfo: {
        title: '【专题】' + '平安好医生2021半年报：营收38.2亿 净亏损8.796亿',
        meta: [
            {
                name: 'keywords',
                content: '平安好医生 财报 净利润 营收'
            },
            {
                name: 'description',
                content: '8月24日，平安健康医疗科技有限公司（股票简称：平安好医生，1833.HK）发布2021年中期业绩报告。'
            }
        ]
    },
    data() {
        return {
            // 头图标题
            banner: {
                img: require('@/assets/2021Q2payscb/banner.jpg'),
                title: [
                    '平安好医生2021半年报：营收38.2亿 净亏损8.796亿',
                    '',
                ],
            },

            // 置顶头条
            headlines: [
                {
                    title: '平安好医生二季报全文下载',
                    url: 'https://www1.hkexnews.hk/listedco/listconews/sehk/2021/0824/2021082400448_c.pdf'
                },
            ],

            // 滚动播报
            broadcast: {
                title: {
                    topic: '滚动播报',
                    more: {
                        name: '我要投诉>',
                        url: '/Index/complain.html'
                    }
                },
                params: {
                    p: 1,
                    n: 5,
                    terms: '平安 财报'
                },
            },

            // 核心数据
            coredata: {
                title: {
                    topic: '核心数据',
                    more: {
                        name: '更多数据>',
                        url: '/Index/dsb_product.html',
                    }
                },
                list: [
                    {
                        img: require('@/assets/2021Q2payscb/cb1.png'),
                        url: ''
                    },
                    {
                        img: require('@/assets/2021Q2payscb/cb2.png'),
                        url: ''
                    },
                    {
                        img: require('@/assets/2021Q2payscb/cb3.png'),
                        url: ''
                    },
                ]
            },

            // 相关专题
            project: {
                title: {
                    topic: '相关专题',
                },
                params: {
                    p: 1,
                    cate: '上市公司',
                    title: '医'
                },
            }
        }
    },
}
</script>

<style>

</style>
